import React, { useState, useEffect } from "react";
import { getProductClassS } from "../../../http/api/ProductClassSAPI";
import { Select, MenuItem, FormControl } from "@mui/material";

const ProductClassSSelect = ({ onChange, value, productClassMId }) => {
  const [listProductClassS, setListProductClassS] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value || "-1");

  async function getListProductClassS() {
    if (!productClassMId || productClassMId <= 0) return;
    let response = await getProductClassS({
      productClassMId,
    });
    setListProductClassS(response.listProductClassSInfo);
  }

  useEffect(() => {
    getListProductClassS();
  }, [productClassMId]);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleSelectionChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <>
      <Select
        value={selectedValue}
        onChange={handleSelectionChange}
        sx={{ width: 400, marginInline: 1 }}
      >
        <MenuItem key="unselected" value="-1">
          [未選択]
        </MenuItem>
        {listProductClassS.map((item) => (
          <MenuItem key={item.productClassSId} value={item.productClassSId}>
            {item.productClassSName}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default ProductClassSSelect;
